import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { RoleSelectionComponent } from './role-selection.component';

const routes: Routes = [
  { path: 'role-selection', component: RoleSelectionComponent, data: { title: extract('Role Selection') } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class RoleSelectionRoutingModule {}
